const menuBtn = document.querySelector('.header__burger');
const menu = document.querySelector('.header__nav');
const menu__link = document.querySelectorAll('.header__nav li.nav__item a');
const overflowHidden = document.querySelector('body');

const hideMenu = (event) => {
  menu.classList.add('menu__hide');
  menuBtn.classList.remove('menu__active');
  overflowHidden.classList.remove('overflowhidden');
  setTimeout(() => {
    menu.classList.remove('menu__active');
    menu.classList.remove(`anim__active`);
    menu.classList.remove('menu__hide');
  }, 400)
}

const close = (event) => !menu.contains(event.target) && hideMenu(event);

menuBtn.addEventListener('click', (event) => {
  event.stopPropagation();

  if(!menu.classList.contains('menu__active')){
    menu.classList.add('menu__active');
    menuBtn.classList.add('menu__active');
    overflowHidden.classList.add('overflowhidden');
    setTimeout(() => {
      menu.classList.add(`anim__active`);
    }, 300)
  } else {
    menu.classList.add('menu__hide');
    menuBtn.classList.remove('menu__active');
    overflowHidden.classList.remove('overflowhidden');
    setTimeout(() => {
      menu.classList.remove('menu__active');
      menu.classList.remove(`anim__active`);
      menu.classList.remove('menu__hide');
    }, 400)
  }
});


$("body").on('click', '[href*="#"]', function(e){
  var fixed_offset = 10;
  menu.classList.remove('menu__active');
  overflowHidden.classList.remove('overflowhidden');
  menuBtn.classList.remove('menu__active');
  $('html,body').stop().animate({ scrollTop: $(this.hash).offset().top - fixed_offset }, 1000);
  e.preventDefault();
})

window.addEventListener('click', close);